var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('vue-splash',{attrs:{"show":_vm.show_splash,"logo":_vm.logo,"color":"#1b4581","size":150,"fixed":true}}),(!_vm.show_splash)?_c('div',[_c('router-view'),_c('Footer')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }